import { ConstMap } from '@/utils/ConstMap';

export enum InsightExplorerViewType {
  VOLUME = 1,
  SENTIMENTS,
}

export enum InsightExplorerFieldType {
  TAG = 'tag',
  TAXONOMY = 'taxonomy',
}

export enum InsightExplorerByType {
  TAG = 1,
  TAXONOMY,
  TAXONOMY_TOPIC,
}

export enum InsightExplorerTrendViewType {
  NEGATIVE_VOLUME = 1,
  SENTIMENT_SCORE,
}

export enum InsightExplorerMetricType {
  VOLUME = 1,
  PERCENTAGE,
}

export const InsightExplorerViewTypeMap = new ConstMap([
  [InsightExplorerViewType.VOLUME, 'Volume'],
  [InsightExplorerViewType.SENTIMENTS, 'Sentiments'],
]);

export const InsightExplorerFieldTypeMap = new ConstMap([
  [InsightExplorerFieldType.TAXONOMY, 'Taxonomy'],
  [InsightExplorerFieldType.TAG, 'Tag'],
]);

export const InsightExplorerByTypeMap = new ConstMap([
  [InsightExplorerByType.TAXONOMY, 'Taxonomy'],
  [InsightExplorerByType.TAG, 'Tag'],
  [InsightExplorerByType.TAXONOMY_TOPIC, 'Taxonomy Topic'],
]);

export const InsightExplorerTrendViewTypeMap = new ConstMap([
  [InsightExplorerTrendViewType.NEGATIVE_VOLUME, 'Negative Volume'],
  [InsightExplorerTrendViewType.SENTIMENT_SCORE, 'Sentiment Score'],
]);

export const InsightExplorerMetricTypeMap = new ConstMap([
  [InsightExplorerMetricType.VOLUME, '#'],
  [InsightExplorerMetricType.PERCENTAGE, '%'],
]);
